import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Box = _resolveComponent("Box")!

  return (_openBlock(), _createBlock(_component_Box, {
    as: _ctx.as,
    role: "menu",
    tabindex: "-1",
    "aria-orientation": "vertical",
    "aria-labelledby": _ctx.id,
    class: _normalizeClass([{ hidden: !_ctx.open }, "p-2 flex flex-col z-50"])
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["as", "aria-labelledby", "class"]))
}